import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import Orders from "@/pages/Orders.vue";
import KanbanTuner from "@/pages/KanbanTuner.vue";
import Suppliers from "@/pages/Suppliers.vue";
import Tenders from "@/pages/Tenders.vue";
import ElProcSy from "@/pages/ElProcSy.vue";
import LandingPage from "@/pages/LandingPage";
import Articles from "@/pages/Articles";
import Settings from "@/pages/Settings";
import Notifications from "@/pages/Notifications";
import ArticleDetails from "@/pages/ArticleDetails";
import SupplierDetails from "@/pages/SupplierDetails";
import TenderDetails from "@/pages/TenderDetails";
import TenderCreateNew from "@/pages/TenderCreateNew";
import UserProfile from "@/pages/UserProfile";
import CompanyProfile from "@/pages/CompanyProfile";
import AutomaticReports from "@/pages/AutomaticReports";
import RolesAndRights from "@/pages/RolesAndRights";
import ElProcSyDetails from "@/pages/ElProcSyDetails";
import Onboarding from "@/pages/Onboarding";

const routes = [
  {
    path: "/",
    name: "LandingPage",
    component: LandingPage
  },
  {
    path: "/onboarding",
    name: "Onboarding",
    component: Onboarding,
    //meta: {
    //  requiresAuth: true
    //}
  },
  {
    path: "/app",
    component: DashboardLayout,
    redirect: "/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "articles",
        name: "Meine Artikel",
        component: Articles,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "orders",
        name: "Meine Bestellungen",
        component: Orders,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "kanban-tuner",
        name: "Kanban Tuner",
        component: KanbanTuner,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "supplier-rating",
        name: "Lieferantenauswertung",
        component: Suppliers,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tenders",
        name: "Preisausschreibung",
        component: Tenders,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tenders/new",
        name: "Neue Preisausschreibung anlegen",
        component: TenderCreateNew,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "elkasy",
        name: "el/ka/sy® On-Demand",
        component: ElProcSy,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "elkasy/:id",
        name: "el/ka/sy® On-Demand Bestelldetails",
        component: ElProcSyDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings",
        name: "Einstellungen",
        component: Settings,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings/user",
        name: "Benutzerprofil",
        component: UserProfile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings/company",
        name: "Unternehmensprofil",
        component: CompanyProfile,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings/reports",
        name: "Automatisierte Berichte",
        component: AutomaticReports,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "settings/roles",
        name: "Rollen und Berechtigungen",
        component: RolesAndRights,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "notifications",
        name: "Notifications",
        component: Notifications,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "article/:id",
        name: "Artikeldetails",
        component: ArticleDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "supplier/:id",
        name: "Lieferantendetails",
        component: SupplierDetails,
        meta: {
          requiresAuth: true
        }
      },
      {
        path: "tenders/:id",
        name: "Preisausschreibung Details",
        component: TenderDetails,
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
